import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {CustomEncoder} from '@app/core/services/http.service';

@Injectable()
export class NullToEmptyStringInterceptor implements HttpInterceptor {
	constructor() {
	}

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const requestType = request.method.toLowerCase();
		if (requestType === 'post' || requestType === 'patch') {
			let newBody;
			if (request.body instanceof HttpParams) {
				newBody = new HttpParams({encoder: new CustomEncoder()});
				const keys = request.body.keys();
				keys.forEach(k => {
					const values = request.body.getAll(k);
					values.forEach(value => {
						let newValue = value;
						if (value === null) {
							newValue = '';
						}
						newBody = newBody.append(k, newValue);
					});
				});
				request = request.clone({
					body: newBody,
				});
			}
		}

		return next.handle(request);
	}
}
